// extracted by mini-css-extract-plugin
export default {"codeLogin":"codeLogin--lmtLb","inputStyle":"inputStyle--T6_sq","getCode":"getCode--WGVEr","submitBtn":"submitBtn--tR1pf","markerAnimationScale":"markerAnimationScale--SKLP3"};